import { render, staticRenderFns } from "./ExpirationMode.vue?vue&type=template&id=645efd32&scoped=true&"
import script from "./ExpirationMode.vue?vue&type=script&lang=js&"
export * from "./ExpirationMode.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationMode.vue?vue&type=style&index=0&id=645efd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645efd32",
  null
  
)

export default component.exports